<template>
  <v-container grid-list-lg ml-0 pl-0>
    <v-layout row wrap>
      <v-flex sm6>
        <h3 class="font-weight-bold">Make Trekking Request</h3>
      </v-flex>
      <v-flex lg12 v-if="trekking_agency.status===1">
        <div v-if="warnings">
          <v-alert
              :key="key"
              :value="true"
              color="error"
              icon="warning"
              outlined
              v-for="key in warnings.total_count">
            {{ warnings[key - 1].title }}
          </v-alert>
        </div>
        <new-trekking-request-form></new-trekking-request-form>
      </v-flex>
      <v-flex lg12 v-else-if="trekking_agency.status && trekking_agency.status!==1">
        <div class="alert alert-warning">
          <v-alert
              class="mb-6"
              type="error">
            Sorry you can't make any requests until your account is verified by DOI
          </v-alert>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import NewTrekkingRequestForm from "@/components/trekkingRequest/NewTrekkingRequestForm";
import {mapGetters} from "vuex";

export default {
  components: {
    NewTrekkingRequestForm
  },
  computed: {
    ...mapGetters({
      trekking_agency: "AuthUser/trekking_agency",
      warnings: "AuthUser/warnings",
    }),
  },
  methods: {},
};
</script>
